/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../CoachMarkAPI',
	'../../../../../lib/@waca/baglass/js/baglass/utils/Utils'

], function ($, APIFactory, CoachMarkAPI, GlassUtils) {

	class CoachMark{

		constructor() {}

		getAPI() {
			return APIFactory.createAPI(this, [CoachMarkAPI]);
		}

		addCoachMark(options) {
			const coachMarksOptions = {
				$el: $(options.domElement),
				...options
			};
			return GlassUtils.addCoachmark(coachMarksOptions);
		}
	}
	return CoachMark;
});
